@if(auctions().length > 0 )
{
<div class="  bg-[#FFF6F2] md:mt-7 w-full md:px-[3.5rem]">
    <div class="w-full container mx-auto ">
        <div class="text-center p-6">
            <p class="text-[var(--dark-teal)] text-3xl font-noto-serif mt-4 ">Featured Auctions</p>
            <p class="text-[var(--fs-dark)] font-dm-sans text-xl">Don’t miss these highlighted events supporting great
                causes.</p>
        </div>
        <div class="grid gap-6 items-stretch  px-[20px] md:px-0 pb-[50px]" [ngClass]="{'grid-cols-2' : !isMobile && !isMobileSmall && auctions()!.length > 1,
            'grid-cols-1': isMobile || isMobileSmall || auctions()!.length == 1
        } ">
            @for (auction of auctions(); track $index; let aIndex = $index) {
            <div class=" grid grid-cols-1 bg-white rounded-2xl shadow-lg p-6 mx-auto" [ngClass]="{'lg:grid-cols-2': auctions()!.length == 1
                }">
                <div [ngClass]="{'mr-[50px]':auctions()!.length == 1 }">

                    <div class="flex items-center gap-3">
                        @if(auction.orgLogoUrl)
                        {
                        <img [src]="auction.orgLogoUrl" [alt]="auction.orgName + ' Logo'"
                            class="w-12 h-12 object-contain cursor-pointer hover:underline"
                            [routerLink]="['/auction', auction.auctionId]">
                        }
                        <a [routerLink]="['/auction', auction.auctionId]" class="cursor-pointer hover:underline">
                            <h3 class="text-[var(--dark-teal)] text-xl font-noto-serif  ">{{auction.orgName}}</h3>
                        </a>
                    </div>
                    <p class="mt-4 mb-10 flex-grow">
                        <span> {{ expanded ? auction.orgMission : (auction.orgMission | slice:0:420) }} </span>
                        <a *ngIf=" auction.orgMission.length > 420"
                            class="text-custom-blue-head  text-xs cursor-pointer ml-1" (click)="toggleExpanded()">
                            {{expanded ? '... See less' : 'See more ...'}}
                        </a>
                    </p>
                </div>
                @if (auction.items.length > 0) {
                <div [ngClass]="{'lg:h-[280px] lg:pt-[70px]':auctions()!.length == 1 }">
                    <p-carousel ngSkipHydration [value]="auction.items" [numVisible]="3" [numScroll]="1"
                        [circular]="true" [responsiveOptions]="responsiveOptions" autoplayInterval="3000"
                        class="custom-carousel">
                        <ng-template let-item #item>
                            <a [routerLink]="['/item-details-bc', 'item', item.itemId]">
                                <div
                                    class="border border-[rgba(77,162,214,1)] rounded-md border-[1px] m-2 p-4 bg-[rgba(243,249,253,1)] shadow-md">
                                    <div class="mb-5">
                                        <div class="relative mx-auto">
                                            <img [src]="absoluteMediaUriService.getAbsoluteMediaUri(item.itemImageUrl)"
                                                [alt]="item.name"
                                                class="w-full rounded-border object-cover aspect-[4/3]" />
                                        </div>
                                    </div>
                                    <div
                                        class="font-noto-serif font-semibold text-sm text-[var(--dark-teal)] leading-tight h-[35px] flex justify-center text-center overflow-hidden">
                                        {{ item.itemName }}</div>
                                </div>
                            </a>
                        </ng-template>
                    </p-carousel>
                </div>
                }
                <p class=" text-center text-[var(--fs-black)] font-medium italic text-sm mt-5">{{
                    timeLeftService.getTimeLeft(auction.orgOpeningDate, auction.orgClosingDate) }}
                </p>
            </div>
            }
        </div>
    </div>
</div>
}